const list={
    searchList:[
        {
            entityField:"start",
            showField:"开始日期",
            searchId:null,
            setField:"",
            fieldWeight:150,
            fieldType:"date",
        },
        {
            entityField:"end",
            showField:"结束日期",
            searchId:null,
            setField:"",
            fieldWeight:150,
            fieldType:"date",
        },
        {
            entityField:"cmName",
            showField:"客户名称",
            searchId:null,
            setField:"cmName",
            fieldWeight:150,
            fieldType:"string",
        },
        {
            entityField:"coName",
            showField:"货主名称",
            searchId:null,
            setField:"coName",
            fieldWeight:150,
            fieldType:"string",
        },
    ],
    list:[
        {
            entityField:"cmName",
            showField:"客户名称",
            fieldWeight:150,
            fieldType:"string",
            isShow:1,
        },
        {
            entityField:"cmCode",
            showField:"客户编码",
            fieldWeight:150,
            fieldType:"string",
            isShow:1,
        },
        {
            entityField:"coName",
            showField:"货主名称",
            fieldWeight:150,
            fieldType:"string",
            isShow:1,
        },
        {
            entityField:"money",
            showField:"金额",
            fieldWeight:100,
            fieldType:"string",
            isShow:1,
        },
        {
            entityField:"tradingTime",
            showField:"交易时间",
            fieldWeight:150,
            fieldType:"date",
            isShow:1,
        },
        {
            entityField:"voucherTime",
            showField:"凭证导出时间",
            fieldWeight:150,
            fieldType:"date",
            isShow:1,
        },
        {
            entityField:"voucherNum",
            showField:"凭证号",
            fieldWeight:150,
            fieldType:"string",
            isShow:1,
        },
        {
            entityField:"createTime",
            showField:"创建时间",
            fieldWeight:150,
            fieldType:"date",
            isShow:1,
        },
        {
            entityField:"createrName",
            showField:"创建人",
            fieldWeight:100,
            fieldType:"string",
            isShow:1,
        }
    ]
}
export default list
